<template>
  <div class="animated fadeIn">
    <div id="snackbar" style="color:red;"></div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Add Advertise With Us Pdf</strong>
            <!-- <small>Form</small> -->
          </div>
          <b-form ref="popupform" v-on:submit.prevent.self="submitFinalData">
            <h5 class="my-3">Upload Document</h5>

            <div class="row">
              <div class="col-3 mb-4 pr-0">
                <label class="material-file-upload">
                  <!-- v-on:change="onFileUpload($event,PosterItem,PosterIndex,MovieContentIndex)" -->
                  <input
                    type="file"
                    accept="application/pdf"
                    v-on:change="uploadPdf($event)"
                    name="pdf"
                    :id="'pdf'"
                  />
                  <div
                    class="label"
                    v-bind:class="{
                      'shift-up': Url.selected_url,
                    }"
                  >
                    <div class="text-truncate">Upload Pdf</div>
                  </div>
                  <div class="uploaded-file-name">
                    <div class="text-truncate pt-2">
                      {{ Url.selected_url }}
                    </div>
                  </div>
                </label>
                <div v-if="Url.uploadPercentage != 0">
                  <div class="row">
                    <div class="col-10 pl-4 pt-2 pr-1">
                      <!-- <progress max="100" class="w-100" :class="Url.uploadPercentage == 100 ? 'bg-success': ''" :value="Url.uploadPercentage"></progress> -->
                      <div class="progress" style="height: 0.5rem">
                        <div
                          class="progress-bar progress-bar-striped"
                          :class="
                            Url.uploadPercentage == 100 ? 'bg-success' : ''
                          "
                          role="progressbar"
                          v-bind:style="{ width: Url.uploadPercentage + '%' }"
                          :aria-valuenow="Url.uploadPercentage"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div class="col-2 p-0" style="font-size: 13px">
                      {{ Url.uploadPercentage + "%" }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- <p class="error_message">
                <span v-if="!Url.selected_url">Please Upload Pdf</span>
              </p> -->
              <div class="col-1 mb-4">
                <a
                  v-if="Url.selected_url"
                  :href="Url.selected_url"
                  target="_blank"
                >
                  <img
                    src="@/assets/img/icons/empty-image.svg"
                    height="35"
                    width="35"
                    class="rounded"
                  />
                </a>
                <img
                  v-else
                  src="@/assets/img/icons/empty-image.svg"
                  height="35"
                  width="35"
                  class="rounded"
                />
              </div>
            </div>

            <b-row class="m-2">
              <b-col sm="4">
                <b-button size="sm" variant="primary" @click="onFinalSubmit">
                  <i class="fa fa-dot-circle-o"></i>
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import draggable from "vuedraggable";
  import MasterService from "@/services/MasterService";
  import ExhibitorService from "@/services/ExhibitorService";
  import { VueEditor } from "vue2-editor";
  import VueCropper from "vue-cropperjs";
  import PosFnbService from "@/services/PosFnbService";
  import signageServices from "@/services/signageService";

  import "cropperjs/dist/cropper.css";

  export default {
    data() {
      return {
        editMode: false,
        bannerType: "",
        bannerIndex: "",
        BaseURL: "",
        Ratings: [],
        isEdit: true,
        staticNames: {
          name: "Add",
        },
        modalObject: {
          title: "fdsfds",
        },
        cinemaListArray: [],
        popupType: 0,
        countryOptions: [],
        LanguageArray: [],
        typeArray: [
          { type_id: 1, type_name: "Schedule" },
          { type_id: 2, type_name: "Offer" },
          { type_id: 3, type_name: "Upcoming Movies" },
        ],
        orientationArray: [
          { o_type_id: 1, o_type_name: "Horizontal" },
          { o_type_id: 2, o_type_name: "Vertical" },
        ],
        pagesList: {
          pp_id: "",
          mpm_id: "",
          main_name: "",
          country_id: "",
          description: "",
          language: "",
          popup_rating_url: "",
          isActive: false,
          popup_rating_title: "",
          banner: "",
          status: "Y",
          ratingType: "",
        },
        error: {
          mpm_id_error_msg: false,
          main_name_error_msg: false,
          country_id_error_msg: false,
          description_error_msg: false,
          language_error_msg: false,
          popup_rating_url_error_msg: false,
          isActive_error_msg: false,
          popup_rating_title_error_msg: false,
          banner_error_msg: false,
          status_error_msg: false,
          ratingType_error_msg: false,
        },
        imageSize: {
          width: 125,
          height: 125,
        },

        imagesVmodel: "",
        imagesIndex: "",
        bannerImg: [],
        CinemasList: [],
        CinemasListCopy: [],
        pageForm: {
          cinema_selected: "",
          display_id: "",
          display_name: "",
          type_selected: "",
          description: "",
          orientation_type: "",
          sliderInSec: 30,
          display_height: 0,
          display_width: 0,
          theme_type: "Red Theme",
        },
        Url: {
          selected_url: "",
          selected_type: "",
          uploadPercentage: 0,
        },

        theme_array: ["Red Theme", "Black Theme"],
        file: "",
        pdfSrc: "",
        cropImg: "",
        filename: "",
        indexofthubmnail: "",
        tempModalImageName: null,
        tempModalImagePath: null,
        tempContentType: "",
      };
    },
    computed: {},
    watch: {},
    beforeMount() {
      if (true) {
        this.isRoleID = false;
      }
      console.log(this.$route, "testa salkfndsglkmn");
      if (this.$route.query.vip_id) {
        console.log(this.$route.query, "query router");
        this.getVipfnbList(this.$route.query.vip_id);
      } else {
        this.$toasted.show("Id Not Found");
      }
      // this.getAllActiveScreens();
      // this.getAllActiveCinemas();
    },
    mounted: function() {},
    methods: {
      getVipfnbList(vip_id) {
        let payload = {
          vip_id,
        };
        PosFnbService.GetVipFnb(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (
                data.Records.hasOwnProperty("data") &&
                data.Records.data.length > 0
              ) {
                this.Url.selected_url = data.Records[0].vip_path;

                // this.signage_url = data.signage_url;
                //   this.Currencies.map(x => {
                //     x["ccr_vip_is_active"] = x["ccr_vip_is_active"] == "Y" ? true : false;
                //   });
              } else {
                this.customErrors.message = data.message;
              }
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {});
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      onFinalSubmit() {
        if (this.Url.selected_url == "") {
          return this.$toasted.show("Please Upload Pdf File");
        }
        let loader = this.$loading.show();
        let v_id = this.$route.query.vip_id;
        let payload = {
          vip_path: this.Url.selected_url,
          vip_id: v_id,
          // meta_data: meta_data,
          // cinema_id: this.pageForm.cinema_selected.cine_id,
        };
        console.log(payload);
        PosFnbService.addeditvipFnb(payload).then((response) => {
          console.log(response, "response");
          const { data } = response;

          loader.hide();

          if (data && data.status == true) {
            // this.Url.selected_url = data.vip_path;
            this.$toasted.show(data.message);
            this.$router.go(-1);
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        });
      },

      cropImage() {
        this.$bvModal.hide("imagecropper");

        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
        var block = this.cropImg.split(";");
        // Get the content type of the image
        var contentType = block[0].split(":")[1]; // In this case "image/gif"
        // get the real base64 content of the file
        var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
        // Convert it to a blob to upload
        var blob1 = this.b64toBlob(realData, contentType);
        this.onThumbnailUpload(blob1, this.filename);
      },

      onThumbnailUpload: function(image, filename, index) {
        let loader = this.$loading.show();
        this.file = e.target.files[0];
        let formData = new FormData();
        formData.append("pdf", this.file);
        // formData.append("imagePath", "vip_fnb");
        let JWT = window.localStorage.getItem("JWT_TOKEN");
        const options = {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: JWT,
            "Access-Control-Allow-Origin": "*",
          },
          onUploadProgress: (event) => {
            const { loaded, total } = event;
            const percent = Math.floor((loaded / total) * 100);
            this.Url.uploadPercentage = percent;
          },
        };
        MasterService.GlobalUploadFile(formData, options)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.Url.selected_url = data.path;
              this.pdfSrc = "";
              // this.$bvModal.hide("imagecropper");
            } else {
              data["message"] && data["message"]["message"]
                ? this.$toasted.show(data.message.message)
                : this.$toasted.show(
                    data.message ||
                      "Sorry! Something went wrong. kindly contact your administrator"
                  );
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },

      uploadPdf: function(file) {
        let self = this;
        let formData = new FormData();
        formData.append("file", file.target.files[0]);
        formData.append("filePath", "Vip Fnb File");
        MasterService.GlobalUploadAllTypeFile(formData)
          .then((response) => {
            console.log(response, "newresponse");
            const { data } = response;
            data.message ? this.$toasted.show(data.message) : "";
            if (data.status) {
              this.Url.selected_url = data.fullpath;
              console.log(
                this.b64toBlob(this.Url.selected_url, "application/pdf"),
                "blob data"
              );
            }
            self.setPdf();
            self.BaseURL = data.BaseURL;
          })
          .catch((error) => {
            this.$toasted.show("Error In Uploading The File");
          });
      },
      //Set pdf
      setPdf: function(e) {
        console.log({ e });
        this.file = e.target.files[0];
        console.log(this.file, "from this,file");
        // this.filename = e.target.files[0]["name"];
        // this.indexofthubmnail = index;

        if (this.file.type.indexOf("application/pdf") !== -1) {
          this.Url.selected_type = "file";
          console.log(typeof FileReader, "typeof FileReader");
          if (typeof FileReader === "function") {
            const reader = new FileReader();
            reader.onload = (event) => {
              console.log(event, "Evnet");
              this.pdfSrc = event.target.result;
              e.target.value = "";
            };
            reader.readAsDataURL(this.file);
            console.log("filename:", this.file);
            this.onThumbnailUpload(this.file, this.file.name, 0);
          } else {
            this.$toasted.show("Error In Uploading The File");
          }
        }
      },
    },
    updated() {},
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/MyCinemas/addAdvertisewithus.vue